import React from "react";
import SalesRevenue from "../SalesRevenue";

const SalesRevenueComponent = () => {
  return <SalesRevenue status="class-allocated" title="class-allocated" />;
};

export default SalesRevenueComponent;
